import { Stack } from 'ui/stack';

const ConfigurationPlaceholder = () => (
  <Stack
    sx={{
      minHeight: '610px',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.5,
      borderRadius: '0.375rem',
      borderWidth: '1px',
      borderColor: 'tokens.navy.100',
      textAlign: 'center',
    }}
    data-testid="configuration-placeholder"
  >
    <p className="text-xl font-semibold leading-7 text-gray-700">
      Configuration
    </p>
    <p className="text-lg font-semibold leading-7 text-gray-500">
      Configuration settings are coming in Phase 2 once the backend schema is
      finalised.
    </p>
  </Stack>
);

export default ConfigurationPlaceholder;
